import { Schema } from 'rsuite'

const { StringType, DateType } = Schema.Types

export const LoyaltyCouponSeriesFormValidationModel = Schema.Model({
  code: StringType()
    .isRequired('Код серии обязателен')
    .minLength(2, 'Код должен содержать минимум 2 символа')
    .maxLength(50, 'Код не должен превышать 50 символов')
    .pattern(/^[A-Z0-9_]+$/, 'Код может содержать только заглавные буквы, цифры и подчеркивания'),
  
  title: StringType()
    .isRequired('Название серии обязательно')
    .minLength(2, 'Название должно содержать минимум 2 символа')
    .maxLength(200, 'Название не должно превышать 200 символов'),
  
  description: StringType()
    .maxLength(1000, 'Описание не должно превышать 1000 символов'),
  
  validFrom: DateType(),
  
  validUntil: DateType()
    .addRule((value: any, data: any) => {
      if (value && data.validFrom && value <= data.validFrom) {
        return false
      }
      return true
    }, 'Дата окончания должна быть позже даты начала')
})
